// @vendors
const get = require('lodash/object/get');
const moment = require('moment');

// @helpers
const apiURLBuilder = require('../core/apiURLBuilder');
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const { getPublicSiteUrl } = require('core/apiURLBuilder');
const errorActions = require('actions/brokerError');
const mifidErrorHelper = require('mifid/utilities/mifidErrorHelper');
const { getLanguage } = require('core/i18n').i18n;

// @constants
const {
    BROKER_FUND_LEGAL_DOCUMENT_MORNING_STAREXT_SECURTY_DETAILS,
    BROKER_INVESTMENT_FUNDS_PRODUCT_URL_PARAMETER,
    BROKER_DOCUMENT_TYPE,
    BROKER_ORDER_TYPE_BUY,
    BROKER_ORDER_TYPE_SELL,
    LEGAL_DOCUMENTS_TYPES
} = require('constants/index');

const {
    BROKER_FUND_LEGAL_DOCUMENT_MORNINGSTAREXT_FETCH,
    BROKER_FUND_LEGAL_DOCUMENT_MORNINGSTAREXT_FETCH_SUCCESS,
    BROKER_FUND_LEGAL_DOCUMENT_MORNINGSTAREXT_FETCH_ERROR,
    BROKER_FUND_LEGAL_DOCUMENT_MARKETING_REPORTS_FETCH_SUCCESS,
    BROKER_FUND_LEGAL_DOCUMENT_COST_FETCH,
    BROKER_FUND_LEGAL_DOCUMENT_COST_FETCH_ERROR,
    BROKER_FUND_LEGAL_DOCUMENT_COST_FETCH_SUCCESS,
    FETCH_ALTERNATIVE_DOCUMENTS_SUCCESS,
    BROKER_FUND_LEGAL_DOCUMENT_COMISION_AND_COST_FETCH,
    BROKER_FUND_LEGAL_DOCUMENT_COMISION_AND_COST_SUCCESS,
    BROKER_FUND_LEGAL_DOCUMENT_COMISION_AND_COST_ERROR,
} = require('constants/actionTypes');


const fetchMorningstarextSuccess = (response, fundIsin) => (dispatch, getState) => dispatch({
    type: BROKER_FUND_LEGAL_DOCUMENT_MORNINGSTAREXT_FETCH_SUCCESS,
    payload: { response, isin: fundIsin, originCountry: getState().profile.get('originCountry') }
});

const fetchMorningstarextError = (error) => (dispatch) => dispatch({
    type: BROKER_FUND_LEGAL_DOCUMENT_MORNINGSTAREXT_FETCH_ERROR,
    payload: { error }
});

const fetchFundTransactionCostSuccess = (response) => ({
    type: BROKER_FUND_LEGAL_DOCUMENT_COST_FETCH_SUCCESS,
    payload: { response }
});

const fetchFundTransactionCostError = (error) => ({
    type: BROKER_FUND_LEGAL_DOCUMENT_COST_FETCH_ERROR,
    payload: { error }
});

const fetchFundTransactionCostRequest = () => ({
    type: BROKER_FUND_LEGAL_DOCUMENT_COST_FETCH,
    payload: {}
});

const fetchCostAndCommisionRequest = () => ({
    type: BROKER_FUND_LEGAL_DOCUMENT_COMISION_AND_COST_FETCH,
});

const fetchCostAndCommisionSuccess = (base64) => ({
    type: BROKER_FUND_LEGAL_DOCUMENT_COMISION_AND_COST_SUCCESS,
    payload: base64
});

const fetchCostAndCommisionError = () => ({
    type: BROKER_FUND_LEGAL_DOCUMENT_COMISION_AND_COST_ERROR,
});

const getFundsTransactionDocumentContent = (objectID, mifidErrorDatePassed, fundIsin, callback, history) => (dispatch) => {
    const data = {
        query: {
            objectId: objectID
        }
    }
    return APIGet(dispatch, apiURLBuilder.getURL('getDocumentContent'), data).then(response => {
        if (response && response.content) {
            const result = {
                [fundIsin]: {
                    objectId: objectID,
                    base64Data: response.content
                }
            };
            dispatch(fetchFundTransactionCostSuccess(result));
            callback()
        } else {
            if (mifidErrorDatePassed) {
                dispatch(errorActions.show("brokerAPIErrors-errorPrimaryMessage", true, history));
            }
        }
    }, (error) => {
        if (mifidErrorDatePassed) {
            dispatch(fetchFundTransactionCostError(error))
            const errorKey = get(error, ["body", "error"], "");
            dispatch(errorActions.show("brokerAPIErrors-" + errorKey, true, history));
        }
    });
};

const fetchMorningstarext = (secId, fundIsin) => (dispatch) => {
    dispatch({
        type: BROKER_FUND_LEGAL_DOCUMENT_MORNINGSTAREXT_FETCH,
        payload: {}
    });

    const url = apiURLBuilder.getURL('morningstarextSecurityDetails', {
        productMorningstarextSecurityDetails: BROKER_FUND_LEGAL_DOCUMENT_MORNING_STAREXT_SECURTY_DETAILS,
        secId
    });

    APIGet(dispatch, url, {}).then(
        (response) => dispatch(fetchMorningstarextSuccess(response, fundIsin)),
        (error) => dispatch(fetchMorningstarextError(error))
    );
};

const fetchMarketingReports = (fundIsin) => (dispatch, getState) => {
    const memories = getState().globalVariables.getIn(['variables', 'parameters', 'memories', 'memories']);
    const originCountry = getState().profile.get('originCountry');
    let publicSiteUrl = getPublicSiteUrl();

    if (!!publicSiteUrl && publicSiteUrl.slice(publicSiteUrl.length - 3, -2) === "/") {
        publicSiteUrl = publicSiteUrl.slice(0, -3);
    }
    const url = (memories
        ? `${publicSiteUrl}${memories.trim()}${fundIsin}.pdf?originCountry=${originCountry}`
        : '');
    dispatch({
        type: BROKER_FUND_LEGAL_DOCUMENT_MARKETING_REPORTS_FETCH_SUCCESS,
        payload: { url }
    });
};

const fetchFundTransactionCost = (fundIsin, callback, isOrderSell, history) => (dispatch, getState) => {
    const immAccessKey = getState().accessKeyChange;
    const lastAccess = immAccessKey.getIn(['cmcContract', 'lastAccess']);
    const mifidErrorDatePassed = mifidErrorHelper.nationalIdDateValidation(lastAccess)
    dispatch(fetchFundTransactionCostRequest());

    const data = {
        "documentType": BROKER_DOCUMENT_TYPE,
        "isin": fundIsin,
        "orderType": isOrderSell ? BROKER_ORDER_TYPE_SELL : BROKER_ORDER_TYPE_BUY
    };

    const requestData = {
        query: data
    };

    APIPost(dispatch, apiURLBuilder.getURL('getProductCost'), requestData).then(
        (response) => {
            if (response && response.objectId) {
                dispatch(getFundsTransactionDocumentContent(response.objectId, mifidErrorDatePassed, fundIsin, callback, history));
            } else {
                if (mifidErrorDatePassed) {
                    dispatch(errorActions.show("brokerAPIErrors-errorPrimaryMessage", true, history));
                }
            }
        },
        (error) => {
            if (mifidErrorDatePassed) {
                dispatch(fetchFundTransactionCostError(error))
                const errorKey = get(error, ["body", "error"], "");
                dispatch(errorActions.show("brokerAPIErrors-" + errorKey, true, history))
            }
            callback() //TODO: devolver error
        }
    );
};

const getMorningStarScreener = fundIsin => (dispatch) => {
    const typeId = BROKER_INVESTMENT_FUNDS_PRODUCT_URL_PARAMETER;

    const requestData = {
        query: {
            securityDataPoints:
                'SecId|ISIN|Name',
            pageSize: 5000,
            outputType: 'json',
            languageId: 'es-ES',
            currencyId: 'EUR',
            universeIds: 'FOEUR$$ALL_2118',
            filters: `ISIN:EQ:${fundIsin}`
        }
    };

    return APIGet(
        dispatch,
        apiURLBuilder.getURL('brokerGetMorningStarScreener', { type: typeId }),
        requestData
    )
        .then(response => {
            if (!!response.rows.length) {
                return dispatch(fetchMorningstarext(response.rows[0].SecId, fundIsin));
            } else {
                return dispatch(fetchMorningstarextError());
            }
        })
        .catch(error => dispatch(fetchMorningstarextError(error)));
};

const fetchCostAndCommision = (fundIsin, callback, history) => (dispatch, getState) => {
    const immCmWalletBuy = getState().cm;
    const immPortfolios = immCmWalletBuy.getIn(['portfolios', 0, 'assetClassInfo'])
    const portfolioArray = []
    immPortfolios.forEach((portfolio) => {
        const subAssetClassInfoArr = portfolio.get('subAssetClassInfo');
        if (!!subAssetClassInfoArr) {
            subAssetClassInfoArr.forEach(subAssetClassInfo => {
                if (subAssetClassInfo.get('subAssetClassIsinInfo')) {
                    const subAssetClassIsinInfo = subAssetClassInfo.getIn(['subAssetClassIsinInfo', 0]).toJS()
                    portfolioArray.push(subAssetClassIsinInfo)
                }
            })
        }
    })

    const selectedFund = portfolioArray.find((fund) => fund.subAssetClassIsin === fundIsin);
    if (!!selectedFund) {
        const currency = selectedFund.currency;
        const amount = selectedFund.subAssetClassFundAmount;
        const fundName = selectedFund.subAssetClassFundName;
        const data = {
            importe: {
                amount: amount,
                currency: currency
            },
            isin: fundIsin,
            name: fundName,
            language: getLanguage(),
        };
        const requestData = {
            header: {
                version: 2
            },
            query: data
        };
        dispatch(fetchCostAndCommisionRequest());
        return APIPost(
            dispatch,
            apiURLBuilder.getURL('procesosContratacion'),
            requestData
        ).then((response) => {
            if (!!response && !!response.content) {
                dispatch(fetchCostAndCommisionSuccess(response.content));
                callback();
            } else {
                dispatch(fetchCostAndCommisionError());
                dispatch(errorActions.show("brokerAPIErrors-errorPrimaryMessage", true, history));
            }
        }).catch((error) => {
            dispatch(fetchCostAndCommisionError());
            const errorKey = get(error, ["body", "error"], "");
            dispatch(errorActions.show("brokerAPIErrors-" + errorKey, true, history))
        })
    } else {
        callback();
    }
};

 const fetchAlternativeFundsLegalDocuments =
   (isin, originCountry, callback, history) => (dispatch, getState) => {
     const { PROSPECTUS, INFORME_SEMESTRAL, DFI, RECOMMENDATIONS, RISKS } = LEGAL_DOCUMENTS_TYPES;
     const immBrokerConvenienceMiFIDTest = getState().brokerConvenienceMiFIDTest;
     const immProfile = getState().profile;
     const immInvestmentFunds = getState().investmentFunds;
     const mifidScore = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'score']);
     const mifidDate = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'lastExecutionDate']);
     const today = moment().format('DD/MM/YYYY');
     const clientCode = immProfile.getIn(['codigoPersona', 'f']);
     const fundName = immInvestmentFunds.getIn(['steps', 0, 'investmentFunds', 'name']);
     const showRiskAssumptionDocument = getState().flagBasedFeatures.get(
        'wealth_funds_show_risk_assumption_document'
      );
     const showRecomendationReport = getState().flagBasedFeatures.get(
        'wealth_funds_show_recommendation_report_document'
      );
     const showPurchaseAnnualReport = getState().flagBasedFeatures.get('wealth_funds_show_transfer_annual_report_document');

     const allFundsLegalDocumentsPdfReqData = ({
         isinName: fundName,
         testDate: moment(mifidDate, 'DD-MM-YYYY HH:mm:ss' ).format('DD/MM/YYYY'),
         testScore: mifidScore,
         purchaseDate: today,
       });

     const legalDocsToFetch = () => {
        const docs = {
            [PROSPECTUS]: {
                url: 'allFundsLegalDocuments',
                kindOfDocument: ['PR'],
                requestData: {},
            },
            [DFI]: { url: 'allFundsLegalDocuments', kindOfDocument: ['PRP', 'KID'], requestData: {} },
        }

        if (showRiskAssumptionDocument) {
            docs[RISKS] = {
                url: 'risksFundsLegalDocumentsPdf',
                kindOfDocument: [],
                requestData: {},
            };
        }
        if (showRecomendationReport) {
        docs[RECOMMENDATIONS] = {
            url: 'recommendationsFundsLegalDocumentsPdf',
            kindOfDocument: [],
            requestData: allFundsLegalDocumentsPdfReqData,
        };
        }
        if (showPurchaseAnnualReport) {
        docs[INFORME_SEMESTRAL] = {
            url: 'allFundsLegalDocuments',
            kindOfDocument: ['SAR'],
            requestData: {},
        };
        }
        return docs;
     };

     const getURL = (documentType, url, extraPathParams) =>
       apiURLBuilder.getURL(url, {
         isin,
         documentType,
         originCountry,
         ...extraPathParams,
       });

     const fetchedProimses = Object.entries(legalDocsToFetch()).map(([documentType, params]) => {
        const url = getURL(documentType, params.url, params.requestData)
       return APIGet(dispatch, url, {}).then(
         ({ documents, content }) => {
           const validDocs = {};
           if (params.kindOfDocument.length === 0 && content) {
             validDocs[documentType] = {originURL: url, urlToOpen: content};
           } else {
             params.kindOfDocument.forEach(kind => {
               const doc = documents.find(doc => doc && doc.kind === kind);
               if (doc) {
                validDocs[documentType] = {originURL: url, urlToOpen: doc.url};
               }
             });
           }

           return validDocs;
         }
       );
     });

     Promise.all(fetchedProimses)
       .then(responses => {
         const response = responses.reduce((acc, val) => Object.assign(acc, val), {});
         dispatch(setAlternativeDocuments(response));
         callback();
       })
       .catch(error => {
         const errorKey = get(error, ['body', 'error'], '');
         dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
       });
   };

const setAlternativeDocuments = payload => dispatch => {
  dispatch({
    type: FETCH_ALTERNATIVE_DOCUMENTS_SUCCESS,
    payload,
  });
};

const fetchLegalDocuments =
    (
        fundIsin,
        secId,
        callback = () => { },
        enableTransactionCost,
        isBuildYourPortfolio,
        history,
    ) =>
        (dispatch) => {
            if (secId) {
                dispatch(fetchMorningstarext(secId, fundIsin));
            } else {
                dispatch(getMorningStarScreener(fundIsin));
            }
            dispatch(fetchMarketingReports(fundIsin));
            if (enableTransactionCost) {
                dispatch(fetchFundTransactionCost(fundIsin, callback, null, history));
            } else {
                if (isBuildYourPortfolio) {
                    dispatch(fetchCostAndCommision(fundIsin, callback, history));
                } else {
                    callback();
                }
            }
        };

const parametrizableFetchFundTransactionCost = (fundIsin, costDocumentType, costOrderType, history) => (dispatch, getState) => {
    const immAccessKey = getState().accessKeyChange;
    const lastAccess = immAccessKey.getIn(['cmcContract', 'lastAccess']);
    const mifidErrorDatePassed = mifidErrorHelper.nationalIdDateValidation(lastAccess)

    dispatch(fetchFundTransactionCostRequest());

    const data = {
        "documentType": costDocumentType,
        "isin": fundIsin,
        "orderType": costOrderType
    };

    const requestData = {
        query: data
    };

    APIPost(dispatch, apiURLBuilder.getURL('getProductCost'), requestData).then(
        (response) => {
            if (response && response.objectId) {
                dispatch(getFundsTransactionDocumentContent(response.objectId, mifidErrorDatePassed, fundIsin, history));
            } else {
                if (mifidErrorDatePassed) {
                    dispatch(errorActions.show("brokerAPIErrors-errorPrimaryMessage", true, history));
                }
            }
        },
        (error) => {
            if (mifidErrorDatePassed) {
                dispatch(fetchFundTransactionCostError(error))
                const errorKey = get(error, ["body", "error"], "");
                dispatch(errorActions.show("brokerAPIErrors-" + errorKey, true, history))
            }
        }
    );
};

const parametrizableFetchLegalDocuments = (fundIsin, secId, costDocumentType, costOrderType, doNotSendCostDocument = false, history) => (dispatch) => {
    if (secId) {
        dispatch(fetchMorningstarext(secId, fundIsin));
    } else {
        dispatch(getMorningStarScreener(fundIsin));
    }
    dispatch(fetchMarketingReports(fundIsin));
    if (!doNotSendCostDocument) {
        dispatch(parametrizableFetchFundTransactionCost(fundIsin, costDocumentType, costOrderType, history));
    }
};

module.exports = {
    fetchMorningstarext,
    fetchMarketingReports,
    fetchLegalDocuments,
    fetchAlternativeFundsLegalDocuments,
    fetchFundTransactionCost,
    parametrizableFetchLegalDocuments
};
